module.exports = __webpack_public_path__ + "img/flag-en.f7c83c4c.svg";